export const BASE_URL = "";
export const POSTS_URL = `/api/posts`;
export const USERS_URL = `/api/users`;
export const UPLOAD_URL = `/api/upload`;
